import {createElement, Component, PropTypes} from 'rlink-react';
import {jsonp} from 'rlink-utils/xhr';
import shopActions from 'rlink-shop/actions';

export default class ShopProvider {
  constructor () {

  }

  loadProduct (identifier, purchaseIdentifier, size, onContentLoad, userCountry) {
    this._getPrice(identifier, userCountry).then((priceData) => {
      shopActions.PriceLoaded(Object.assign(priceData, {identifier: identifier}));
    });

    let purchaseId = (purchaseIdentifier) ? purchaseIdentifier : identifier;
    shopActions.ModalContentLoaded({
      content: this._getModalContent(purchaseId, size, onContentLoad),
      identifier: identifier,
      renderComplete: false
    });

  }

  openModal (ev, identifier, modal) {
    shopActions.OpenModal(Object.assign(ev, { identifier: identifier, modal: modal }));
  }

  closeModal (ev, identifier, modal) {
    shopActions.CloseModal(Object.assign(ev, { identifier: identifier, modal: modal }));
  }
}



// WEBPACK FOOTER //
// ./lib/rlink-shop/service/base.jsx